import { Container } from 'rsuite';
import styled from 'styled-components';

export const ContainerStyled = styled(Container)`
  min-width: 1024px;
`;
